import { Config } from "../common";

export const getFullImageUrl = (contentLocation?: string | null): string => {
  if (!contentLocation) return "";
  if (contentLocation.startsWith("http://") || contentLocation.startsWith("https://")) {
    return contentLocation;
  }
  let cleanPath = contentLocation.replace(/\\/g, "/").trim();
  const contentsIdx = cleanPath.indexOf("contents/");
  if (contentsIdx !== -1) {
    cleanPath = cleanPath.substring(contentsIdx);
  } else if (!cleanPath.startsWith("contents/")) {
    cleanPath = `contents/${cleanPath.replace(/^\/+/, "")}`;
  }
  cleanPath = cleanPath.replace(/^\/+/, "");
  const baseUrl = (Config.server.baseUrl || "").replace(/\/+$/, "");
  return `${baseUrl}/${cleanPath}`;
};
